// extracted by mini-css-extract-plugin
export default {"subHeading":"ResetPage_subHeading__Fp1N4","backBtn":"ResetPage_backBtn__lBfla","emailError":"ResetPage_emailError__BNQfa"};